module.exports = __webpack_public_path__ + "media/images/payment/logo_paypay-cff4ae56720ab93df16c251724746531.gif";